import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-dialog-header-student-predmety',
    templateUrl: './dialog-header-student-predmety.component.html',
    styleUrls: ['./dialog-header-student-predmety.component.css'],
    standalone: false
})
export class DialogHeaderStudentPredmetyComponent {

  @Input() titulok: string;
  @Input() predmetNazov: string;
  @Input() predmetyPole: string;
  @Input() predmetSkratka: string;
  @Input() predmetRozsah: string;

  @Input() skratkyANazvyPredmetov: string[][];

}
